"use strict";

exports.__esModule = true;
exports.default = void 0;

/** Variable interne qui crée un symbol unique. */
var _default = Symbol();

exports.default = _default;